export default __webpack_public_path__ + "static/media/award5.397c556c.jpg";